/**
 * /dashboard/accounting/items/new — Create item (G_ACC3b).
 *
 * Migration note (Phase 3e — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/accounting/items/new/page.tsx.
 */

import { createFileRoute } from "@tanstack/react-router";
import { AccountingModuleShell } from "@/components/shared/accounting-module-shell";
import { ItemForm } from "@/components/accounting/item-form";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/accounting/items/new",
)({
  component: NewItemRoute,
});

function NewItemRoute() {
  // Top-of-page Back button removed per Audit 4 Quick-Win #4 — the
  // bottom Cancel handles it.
  return (
    <AccountingModuleShell
      title="Add an Item"
      description="Add a good or service to your catalogue."
    >
      <Card className="max-w-3xl">
        <CardContent className="pt-6">
          <ItemForm />
        </CardContent>
      </Card>
    </AccountingModuleShell>
  );
}
